/**
 * Mobile Institutional Intelligence Page
 *
 * Mobile view of the Wolfox Intelligence archive. Reuses the shared
 * WolfoxWidget (which renders its own responsive iframe) inside the
 * standard mobile layout.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import MobileLayout from './MobileLayout';
import WolfoxWidget from '../../components/Wolfox/WolfoxWidget';

function MobileIntelligenceCentre() {
    const navigate = useNavigate();

    return (
        <MobileLayout
            title="Institutional Intelligence"
            showBackButton={true}
            onBackClick={() => navigate('/mobile')}
            backButtonIcon="home"
            infoTooltip="Official updates from regulators, central banks, EU institutions, international authorities and associations"
        >
            <div className="container mt-4">
                <WolfoxWidget type="intelligence" />
            </div>
        </MobileLayout>
    );
}

export default MobileIntelligenceCentre;
